import { lang, t } from './index'
import { localeOf } from './langs'

/**
 * Длительности и вес словами текущего языка (план `docs/i18n-plan.md`, раздел 6.4).
 *
 * Единицы берутся из словаря, числа собираются здесь, чтобы «5 900 г» и «1 ч 10 мин»
 * выглядели одинаково на всех экранах и в пушах, которые приложение считает само.
 * Между числом и единицей веса — неразрывный пробел, между тысячами — узкий: иначе
 * число отрывается от единицы на переносе.
 */

/** «7 ч 40 мин» / «45 мин». */
export function formatHours(minutes: number): string {
  const h = Math.floor(minutes / 60)
  const m = Math.round(minutes % 60)
  if (h === 0) return `${m} ${t('min_unit')}`
  return m === 0 ? `${h} ${t('unit_hours')}` : `${h} ${t('unit_hours')} ${m} ${t('min_unit')}`
}

/** «2 нед» / «12 дн.» — срок между взвешиваниями. */
export function formatSpan(days: number): string {
  return days >= 14 ? `${Math.round(days / 7)} ${t('unit_weeks')}` : `${days} ${t('unit_days')}`
}

/** «5 900» — число граммов без единицы, для клавиатуры веса, где единица стоит отдельно. */
export function formatGramsNumber(grams: number): string {
  const s = String(Math.round(grams))
  return s.length > 3 ? `${s.slice(0, -3)} ${s.slice(-3)}` : s
}

/** «5 900 г» — с тонким пробелом между тысячами. */
export function formatGrams(grams: number): string {
  return `${formatGramsNumber(grams)} ${t('grams_short')}`
}

/** «+380 г» / «−120 г». */
export function formatDelta(grams: number): string {
  const знак = grams > 0 ? '+' : grams < 0 ? '−' : ''
  return `${знак}${formatGrams(Math.abs(grams))}`
}

/** Число с одним знаком после запятой по правилам языка: «5,3» и «5.3». */
export function formatDecimal(value: number): string {
  return new Intl.NumberFormat(localeOf(lang.value), { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(value)
}

/**
 * «4,2–5,6 кг» — коридор для текста пуша и справки.
 *
 * Разделитель дробной части — по языку: запятая в русском и испанском, точка в английском
 * и китайском. Раньше запятая стояла жёстко, и китайский текст читался чужим (09.10.2026).
 */
export function formatCorridorKg(low: number, high: number): string {
  return `${formatDecimal(low / 1000)}–${formatDecimal(high / 1000)} ${t('unit_kg')}`
}
